﻿import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailSignaturOngoing extends GuiDetailGeneric {
    constructor() {
        super("GuiDetailSignaturOngoing");

        this.lock();

        setTimeout(function() {
            location.reload();
        }, 5000);
    }
}
